import React, { useEffect, useState } from 'react';
import RemindMeButton from './RemindMeButton';
import ShareCountdownButton from './ShareCountdownButton';

// Data finale interpretata in ora italiana (fine giornata locale approssimata alle 20:00 CEST)
const getTarget = (dateStr) => new Date(`${dateStr}T20:00:00+02:00`).getTime();

const computeParts = (target) => {
  const diff = Math.max(0, target - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    minutes: Math.floor((diff / 60000) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    done: diff === 0,
  };
};

const pad = (n) => String(n).padStart(2, '0');

const Unit = ({ value, label, testId }) => (
  <div className="flex flex-col items-center min-w-[64px] sm:min-w-[96px]" data-testid={testId}>
    <div
      key={value}
      className="tp-flip w-full text-center rounded-lg border border-red-600/40 px-2 py-2 sm:py-3 text-3xl sm:text-5xl md:text-6xl font-bold text-white"
      style={{ fontFamily: 'Bebas Neue, sans-serif', backgroundColor: 'var(--tp-dark)', letterSpacing: '2px', boxShadow: '0 0 24px rgba(220,38,38,0.25)' }}
    >
      {pad(value)}
    </div>
    <span className="mt-1.5 text-[10px] sm:text-xs tracking-[3px] text-gray-400" style={{ fontFamily: 'Oswald, sans-serif' }}>{label}</span>
  </div>
);

const FinalCountdown = ({ date, label }) => {
  const [parts, setParts] = useState(() => computeParts(getTarget(date)));

  useEffect(() => {
    const target = getTarget(date);
    setParts(computeParts(target));
    const id = setInterval(() => setParts(computeParts(target)), 1000);
    return () => clearInterval(id);
  }, [date]);

  const formatted = new Date(`${date}T12:00:00`).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <section className="px-4 py-6 sm:py-8" style={{ backgroundColor: 'var(--tp-black)' }} data-testid="final-countdown-section">
      <style>{`
        @keyframes tpFlip { 0% { transform: rotateX(-90deg); opacity: 0; } 100% { transform: rotateX(0); opacity: 1; } }
        .tp-flip { animation: tpFlip 0.45s ease-out; transform-origin: top; }
        @keyframes tpPulseLine { 0%,100% { opacity: .4; transform: scaleX(.6);} 50% { opacity: 1; transform: scaleX(1);} }
        .tp-pulse-line { animation: tpPulseLine 2.4s ease-in-out infinite; }
      `}</style>
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-xs sm:text-sm tracking-[4px] mb-1" style={{ fontFamily: 'Oswald, sans-serif', color: 'var(--tp-red)' }} data-testid="final-countdown-label">
          {label}
        </p>
        <h3 className="text-2xl sm:text-4xl font-bold text-white mb-1" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '3px' }} data-testid="final-countdown-date">
          {formatted.toUpperCase()}
        </h3>
        <div className="tp-pulse-line w-24 h-1 mx-auto mb-5 sm:mb-6" style={{ backgroundColor: 'var(--tp-red)' }} />
        {parts.done ? (
          <p className="text-white text-xl sm:text-3xl font-bold" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }} data-testid="final-countdown-done">
            È IL GIORNO DELLA FINALE!
          </p>
        ) : (
          <div className="flex items-start justify-center gap-2 sm:gap-4" data-testid="final-countdown-timer">
            <Unit value={parts.days} label="GIORNI" testId="countdown-days" />
            <span className="text-3xl sm:text-5xl text-red-600 font-bold mt-2 sm:mt-3">:</span>
            <Unit value={parts.hours} label="ORE" testId="countdown-hours" />
            <span className="text-3xl sm:text-5xl text-red-600 font-bold mt-2 sm:mt-3">:</span>
            <Unit value={parts.minutes} label="MINUTI" testId="countdown-minutes" />
            <span className="text-3xl sm:text-5xl text-red-600 font-bold mt-2 sm:mt-3">:</span>
            <Unit value={parts.seconds} label="SECONDI" testId="countdown-seconds" />
          </div>
        )}
        {!parts.done && (
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            <RemindMeButton date={date} />
            <ShareCountdownButton date={date} />
          </div>
        )}
      </div>
    </section>
  );
};

export default FinalCountdown;
